export const home = {
  hero: {
    title1: '專業影視器材',
    title2: '租賃服務',
    title3: 'LensBank',
    subtitle: '與國內外專業影人合作多年的專業器材租賃服務',
    cta1: '立即租借',
    cta2: '拍攝服務'
  },
  services: {
    title: '核心服務',
    equipment: {
      title: '專業器材租賃',
      desc: '超過 1,000+ 件專業攝影器材，滿足各種拍攝需求',
      badge: '1,000+ 件器材'
    },
    taiwanJapan: {
      title: '台日拍攝服務',
      desc: '跨境拍攝全方位支援，器材、團隊、場地一站式解決'
    },
    urent: {
      title: 'Urent 寄租服務',
      desc: '閒置器材變現金，專業保管與租賃管理'
    },
    postProduction: {
      title: '日本剪輯調光',
      desc: '高端廣告等級後製服務，專業團隊品質保證'
    },
    about: {
      title: '關於 LensBank',
      desc: '十多年專業經驗，值得信賴的影像創作夥伴'
    }
  },
  locations: {
    title: '我們的據點',
    viewAll: '查看所有據點',
    store: '門市',
    warehouse: '倉庫',
    hours: '營業時間',
    address: '地址'
  },
  stats: {
    equipment: '專業器材',
    locations: '服務據點',
    experience: '服務經驗',
    clients: '合作客戶'
  }
};